import React from 'react'
import FooterTop from './FooterTop'
import FooterBottom from './FooterBottom'

const Footer = () => {
  return (
    <div className='font-titleFont'>
        <FooterTop/>
        <FooterBottom/>
    </div>
  )
}

export default Footer